import { Localizations } from 'localize'

Localizations.append({
  modules: {
    pickupInstructions: {
      title: 'Pickup address & instructions',
      address: 'Address:',
      instructions: 'Instructions:'
    }
  }
})
